import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GroupTask,
  GroupTaskFiltersPayload,
  GroupTaskReg,
  GroupTasksDataResponse,
  TaskFromGroupTaskResponse
} from '../store/rmmGroupTasks/model';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GroupTasksService {
  private http = inject(HttpClient);
  private config = inject(ConfigurationService);

  private serverUrl: string;
  private mbsStageKey: string;
  private apiEndPoint = 'api/groupTasks' as const;
  private httpParams: GroupTaskFiltersPayload = {};

  constructor() {
    this.serverUrl = this.config.get('rmmBaseHref');
    this.mbsStageKey = this.config.get('mbsStageKey');
    if (this.mbsStageKey) this.httpParams.mbsStageKey = this.mbsStageKey;
  }

  getGroupTasks(httpParams: GroupTaskFiltersPayload): Observable<GroupTasksDataResponse> {
    if (this.mbsStageKey) httpParams.mbsStageKey = this.mbsStageKey;
    httpParams.all = true;
    // parameter to get all kinds of GroupTasks below
    httpParams.policy = '';
    return this.http.get<GroupTasksDataResponse>(`${this.serverUrl}/${this.apiEndPoint}`, { params: httpParams });
  }

  getGroupTasksOpt(httpParams: GroupTaskFiltersPayload): Observable<GroupTasksDataResponse> {
    if (this.mbsStageKey) httpParams.mbsStageKey = this.mbsStageKey;
    return this.http.get<GroupTasksDataResponse>(`${this.serverUrl}/${this.apiEndPoint}Opt`, { params: httpParams });
  }

  getGroupTasksInfoOpt(groupTaskGuidList: string[], httpParams: GroupTaskFiltersPayload): Observable<GroupTask[]> {
    if (this.mbsStageKey) httpParams.mbsStageKey = this.mbsStageKey;
    return this.http.post<GroupTask[]>(`${this.serverUrl}/${this.apiEndPoint}Counts`, groupTaskGuidList, { params: httpParams });
  }

  getGroupTask(groupTaskGuid: string): Observable<GroupTask> {
    return this.http.get<GroupTask>(`${this.serverUrl}/${this.apiEndPoint}/${groupTaskGuid}`, { params: this.httpParams });
  }

  registerGroupTask(task: GroupTaskReg): Observable<string> {
    return this.http.post<any>(`${this.serverUrl}/${this.apiEndPoint}/register`, task, { params: this.httpParams });
  }

  updateGroupTask(groupTaskGuid: string, update: any): Observable<string> {
    return this.http.put<any>(`${this.serverUrl}/${this.apiEndPoint}/${groupTaskGuid}`, update, { params: this.httpParams });
  }

  deleteGroupTask(groupTaskGuid: string): Observable<any> {
    return this.http.delete(`${this.serverUrl}/${this.apiEndPoint}/${groupTaskGuid}`, { params: this.httpParams });
  }

  getTasksFromGroupTask(groupTaskGuid: string, httpParams: GroupTaskFiltersPayload): Observable<TaskFromGroupTaskResponse> {
    if (this.mbsStageKey) httpParams.mbsStageKey = this.mbsStageKey;
    return this.http.get<TaskFromGroupTaskResponse>(`${this.serverUrl}/${this.apiEndPoint}/${groupTaskGuid}/tasks`, { params: httpParams });
  }

  executeGroupTask(hid: string, groupTaskGuid: string): Observable<any> {
    this.httpParams.groupTaskGuid = groupTaskGuid;
    return this.http.post(`${this.serverUrl}/api/Computers/rm/${hid}/commands/forcegrouptask`, null, { params: this.httpParams });
  }

  executeGroupTaskNew(groupTaskGuid: string): Observable<any> {
    return this.http.put(`${this.serverUrl}/${this.apiEndPoint}/${groupTaskGuid}/runnow`, null, { params: this.httpParams });
  }

  changeGroupTaskStateUtility(groupTaskGuid: string, state: boolean): Observable<string> {
    if (state === true) return this.enableGroupTask(groupTaskGuid);
    return this.disableGroupTask(groupTaskGuid);
  }

  disableGroupTask(groupTaskGuid: string): Observable<string> {
    return this.http.post<any>(`${this.serverUrl}/${this.apiEndPoint}/${groupTaskGuid}/disable`, null, { params: this.httpParams });
  }

  enableGroupTask(groupTaskGuid: string): Observable<string> {
    return this.http.post<any>(`${this.serverUrl}/${this.apiEndPoint}/${groupTaskGuid}/enable`, null, { params: this.httpParams });
  }
}
